<template>
  <div>
    <h3>主要设备清单</h3>
    <el-table :data="dataList" size="small">
      <el-table-column type="selection" fixed="left"></el-table-column>
      <el-table-column label="序号" align="center" width="90px">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="majorDivice" label="主要设备" header-align="center" align="center" width="151px">
        <template slot-scope="scope">
          <span>{{scope.row.majorDivice}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="model" label="规格型号" header-align="center" align="center" width="151px">
        <template slot-scope="scope">
          <span>{{scope.row.model}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="num" label="数量" header-align="center" align="center" width="151px">
        <template slot-scope="scope">
          <span>{{scope.row.num}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="exFactoryDate" label="出厂日期" header-align="center" align="center" width="250px">
        <template slot-scope="scope">
          <span>{{scope.row.exFactoryDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="placeOfProduction" label="设备厂家" header-align="center" align="center" width="151px">
        <template slot-scope="scope">
          <span>{{scope.row.placeOfProduction}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="" label="设备参数" header-align="center" align="center" width="151px">
        <template slot-scope="scope">
          <el-button icon="el-icon-upload2" type="text" @click="fileView(scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10,15,20]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>

    <el-dialog
          title="提示"
          :visible.sync="fileDialogVisible"
          width="60%"
          :modal="false"
          >

          <!-- 上传下载 产看 需求文档 -->
            <FileUpDown ref="FileUpDown" :fileSubType="FILE_SUB_TYPE" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE"></FileUpDown>

          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="fileDialogVisible = false">关 闭</el-button>
          </span>
        </el-dialog>
  </div>
</template>

<script>
import {getSupplieInfo7} from '@/controller/supplier'
import FileUpDown from "@/views/common/file-up-down"

export default {
  data () {
    return {
      // 附件类型-供应商门户
      FILE_BIZ_TYPE:14,
      // 附件小类型-主要设备清单
      FILE_SUB_TYPE:1,
      fileDialogVisible:false,
      show:false,
      dataList: [],
      totalPage: 0,
      pageIndex:1,
      pageSize:10,
      majorDivice:'',
      model: '',
      num: '',
      exFactoryDate: '',
      placeOfProduction:'',
      originalValue:'',
      accuracy:'',
      venderInviteFid: '',
      email: '',
      // applyStatus: ''
      dataForm:{
        id:''
      },
    }
  },
  components: {
      FileUpDown //上传附件
  },
  props: {
    superId: Number
  },
  methods: {
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    getDataList() {
      getSupplieInfo7({
        'pageNo': this.pageIndex,
        'pageSize': this.pageSize,
        'id' : this.superId
      }).then(data => {
        if (data && data.code === '00') {
          if (data.body.records.length > 0){
            this.dataList = data.body.records
            this.totalPage = data.body.total
          }
        } else {
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 文件列表
    fileView(row){
      this.dataForm.id = row.id;
      this.fileDialogVisible = true
      this.$nextTick(()=>{
          this.$refs.FileUpDown.init(this.dataForm.id, this.FILE_BIZ_TYPE, null)
      })
    },
  }
}
</script>